import { PROFILE_TYPE } from "../constants";

export class Onboarding {
  // type: PROFILE_TYPE; // TIP not necessary because only profile private uses onboarding
  email?: string; // TIP from Auth0

  // TIP below fields required from onboarding
  firstName?: string;
  lastName?: string;
  birthDate?: Date | string;
  birthPlace?: string;
  address?: Address;
  taxCode?: string;
  cellPhone?: string;
  // TIP above fields required from onboarding
  
  // TIP not used
  job?: string;
  commuter?: string;
  privacyPolicy?: boolean;
  termsAndConditions?: boolean;
  marketing?: boolean;
  thirdParty?: boolean;
}

export class Address {
  city?: string;
  cap?: string;
  street?: string;
  country?: string;
}